import { PLATFORMS, INF_STAGES, SCHOOL_TYPES, SCHOOL_STAGES, PILOT_INTEREST, CAMPAIGN_TYPES, CAMPAIGN_STATUS, CHANNELS, CONTENT_TYPES, CONTENT_STATUS, OWNERS4, PRIORITY4, asOpts } from "@/data/marketingOptions";

const REL = [1, 2, 3, 4, 5].map((n) => ({ value: String(n), label: `${n} / 5` }));

export const influencerFields = () => [
  { name: "name", label: "Influencer name", type: "text", required: true, placeholder: "e.g. @PlayfulParents" },
  { name: "platform", label: "Platform", type: "select", options: PLATFORMS, required: true },
  { name: "profile_url", label: "Profile URL", type: "text", placeholder: "https://" },
  { name: "contact_name", label: "Contact name", type: "text" },
  { name: "contact_email", label: "Contact email", type: "text" },
  { name: "stage", label: "Stage", type: "select", options: asOpts(INF_STAGES), required: true },
  { name: "priority", label: "Priority", type: "select", options: PRIORITY4, required: true },
  { name: "relevance", label: "Relevance (1-5)", type: "select", options: REL },
  { name: "audience_size", label: "Audience size", type: "text", placeholder: "0" },
  { name: "primary_audience", label: "Primary audience", type: "text" },
  { name: "geography", label: "Geography", type: "text" },
  { name: "offer_proposed", label: "Offer proposed", type: "text" },
  { name: "agreed_fee", label: "Agreed fee (£)", type: "text", placeholder: "0" },
  { name: "commission_pct", label: "Commission %", type: "text", placeholder: "0-100" },
  { name: "discount_code", label: "Discount code", type: "text" },
  { name: "customer_offer", label: "Customer offer", type: "text" },
  { name: "content_agreed", label: "Content agreed", type: "text" },
  { name: "planned_publication_date", label: "Planned publication", type: "date" },
  { name: "next_follow_up_date", label: "Next follow-up", type: "date" },
  { name: "next_action", label: "Next action", type: "textarea" },
  { name: "estimated_reach", label: "Estimated reach", type: "text", placeholder: "0" },
  { name: "actual_reach", label: "Actual reach", type: "text", placeholder: "0" },
  { name: "link_clicks", label: "Link clicks", type: "text", placeholder: "0" },
  { name: "prelaunch_signups", label: "Pre-launch sign-ups", type: "text", placeholder: "0" },
  { name: "paid_subscriptions", label: "Paid subscriptions", type: "text", placeholder: "0" },
  { name: "revenue_attributed", label: "Revenue attributed (£)", type: "text", placeholder: "0" },
  { name: "status_summary", label: "Status summary", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const schoolFields = () => [
  { name: "name", label: "School name", type: "text", required: true },
  { name: "school_type", label: "School type", type: "select", options: SCHOOL_TYPES, required: true },
  { name: "region", label: "Local authority / region", type: "text" },
  { name: "country", label: "Country", type: "text" },
  { name: "website", label: "Website", type: "text", placeholder: "https://" },
  { name: "contact_name", label: "Contact name", type: "text" },
  { name: "contact_role", label: "Contact role", type: "text" },
  { name: "contact_email", label: "Contact email", type: "text" },
  { name: "contact_phone", label: "Contact phone", type: "text" },
  { name: "num_pupils", label: "Number of pupils", type: "text", placeholder: "0" },
  { name: "target_age_range", label: "Target age range", type: "text", placeholder: "e.g. 4-8" },
  { name: "stage", label: "Stage", type: "select", options: asOpts(SCHOOL_STAGES), required: true },
  { name: "priority", label: "Priority", type: "select", options: PRIORITY4, required: true },
  { name: "pilot_interest", label: "Pilot interest", type: "select", options: PILOT_INTEREST },
  { name: "proposed_pilot_start", label: "Proposed pilot start", type: "date" },
  { name: "proposed_pilot_duration", label: "Pilot duration", type: "text", placeholder: "e.g. 6 weeks" },
  { name: "num_pilot_pupils", label: "Pilot pupils", type: "text", placeholder: "0" },
  { name: "newsletter_interest", label: "Newsletter interest", type: "text" },
  { name: "free_access_offer", label: "Free-access offer", type: "text" },
  { name: "next_follow_up_date", label: "Next follow-up", type: "date" },
  { name: "next_action", label: "Next action", type: "textarea" },
  { name: "status_summary", label: "Status summary", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const campaignFields = () => [
  { name: "name", label: "Campaign name", type: "text", required: true },
  { name: "campaign_type", label: "Type", type: "select", options: CAMPAIGN_TYPES, required: true },
  { name: "status", label: "Status", type: "select", options: asOpts(CAMPAIGN_STATUS), required: true },
  { name: "owner", label: "Owner", type: "select", options: OWNERS4, required: true },
  { name: "channel", label: "Channel", type: "select", options: CHANNELS },
  { name: "objective", label: "Objective", type: "textarea" },
  { name: "target_audience", label: "Target audience", type: "text" },
  { name: "start_date", label: "Start date", type: "date" },
  { name: "end_date", label: "End date", type: "date" },
  { name: "planned_budget", label: "Planned budget (£)", type: "text", placeholder: "0" },
  { name: "actual_spend", label: "Actual spend (£)", type: "text", placeholder: "0" },
  { name: "main_offer", label: "Main offer", type: "text" },
  { name: "discount_code", label: "Discount code", type: "text" },
  { name: "landing_page", label: "Landing page", type: "text" },
  { name: "impressions", label: "Impressions", type: "text", placeholder: "0" },
  { name: "reach", label: "Reach", type: "text", placeholder: "0" },
  { name: "link_clicks", label: "Link clicks", type: "text", placeholder: "0" },
  { name: "prelaunch_signups", label: "Pre-launch sign-ups", type: "text", placeholder: "0" },
  { name: "trial_starts", label: "Trial starts", type: "text", placeholder: "0" },
  { name: "paid_subscriptions", label: "Paid subscriptions", type: "text", placeholder: "0" },
  { name: "revenue_attributed", label: "Revenue attributed (£)", type: "text", placeholder: "0" },
  { name: "notes", label: "Notes", type: "textarea" },
  { name: "learning_summary", label: "Learning summary", type: "textarea" },
];

export const contentFields = (campaignOpts) => [
  { name: "title", label: "Content title", type: "text", required: true },
  { name: "content_type", label: "Type", type: "select", options: CONTENT_TYPES, required: true },
  { name: "status", label: "Status", type: "select", options: asOpts(CONTENT_STATUS), required: true },
  { name: "platform", label: "Platform", type: "text" },
  { name: "campaign_id", label: "Campaign", type: "select", options: campaignOpts },
  { name: "owner", label: "Owner", type: "select", options: OWNERS4 },
  { name: "planned_publication_date", label: "Planned publication", type: "date" },
  { name: "actual_publication_date", label: "Actual publication", type: "date" },
  { name: "target_audience", label: "Target audience", type: "text" },
  { name: "main_message", label: "Main message", type: "textarea" },
  { name: "caption", label: "Caption / copy", type: "textarea" },
  { name: "call_to_action", label: "Call to action", type: "text" },
  { name: "asset_link", label: "Asset link", type: "text" },
  { name: "results_summary", label: "Results summary", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const interactionFields = (types) => [
  { name: "interaction_type", label: "Type", type: "select", options: types, required: true },
  { name: "date", label: "Date", type: "date" },
  { name: "contact_person", label: "Contact person", type: "text" },
  { name: "summary", label: "Summary", type: "textarea", required: true },
  { name: "outcome", label: "Outcome", type: "textarea" },
  { name: "next_action", label: "Next action", type: "textarea" },
  { name: "next_follow_up_date", label: "Next follow-up date", type: "date" },
  { name: "notes", label: "Notes", type: "textarea" },
];
